import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cloudChiprApi,
  ProviderType,
} from "../../../../services/cloudchipr.api";
import { getSavingsOpportunitiesFixedCacheKey } from "@/store/savings-opportunities/utils/helpers/fixedCacheKeys";

export const getSavingsOpportunityByResourceIdThunk = createAsyncThunk(
  "savingsOpportunities/getSavingsOpportunityByResourceId",
  async (
    { resourceId, provider }: { provider: ProviderType; resourceId: string },
    { dispatch },
  ) => {
    const { postOrganisationsCurrentSavingsOpportunities } =
      cloudChiprApi.endpoints;

    return await dispatch(
      postOrganisationsCurrentSavingsOpportunities.initiate(
        {
          body: {
            filter_tree: {
              node_type: "group",
              operator: "and",
              items: [
                {
                  operator: "in",
                  node_type: "item",
                  type: "resource_id",
                  value: [resourceId],
                  filter_provider: provider,
                },
              ],
            },
          },
        },
        { fixedCacheKey: getSavingsOpportunitiesFixedCacheKey(resourceId) },
      ),
    ).unwrap();
  },
);
